import { Checkbox, Divider, Drawer, FormLabel, Grid, IconButton, styled, Tab, Tabs, Typography } from '@material-ui/core';
import { Cancel, CheckCircle, Close, Description, GetApp } from '@material-ui/icons';
import { operacaoStatusDescriptions } from 'common/genericDescriptions';
import {
  ApproveOfertaPrimariaRequest,
  Comprovante,
  ComprovanteInvestidorResponse,
  FuncaoParticipante,
  OfertaPrimariaInvestidorResponse,
  OfertaPrimariaStatus,
  OperacaoOfertaPrimariaResponse,
  TipoLiquidacao
} from 'common/genericTypes';
import { HorizontalAppBar } from 'components/horizontalAppBar';
import { Button, LgSpace, MdSpace, Section, SmSpace } from 'm2m.components';
import React, { useCallback, useEffect, useState } from 'react';
import { formatDate } from 'utils/date';
import { addCpfCnpjMask } from 'utils/mask';
import { formatEightDecimalsCurrency, formatNumber } from 'utils/number';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { addAlert } from 'store/modules/snackBar';
import ComprovanteComponent from './comprovante';
import { GenericDrawer } from 'components/genericDrawer';
import { useGenericStyles } from 'common/genericStyles';
import UploadDocs, { Attachment } from 'components/uploadDocs';
import { v4 as uuid } from 'uuid';

enum DrawerAction {
  CONFIRMAR,
  REJEITAR,
}

type ComponentParams = { operacaoId: string, filtro?: string };
type ComponentState = { initialTab?: number };

type Props = RouteComponentProps<ComponentParams, {}, ComponentState>;

const CustomCheckbox = styled(Checkbox)(({ theme }) => ({
  color: theme.palette.grey[500],
  '&.Mui-checked': {
    color: theme.palette.success.main,
  },
}));


const DetalhesOfertaPrimaria: React.FC<Props> = (props) => {
  const { operacaoId } = props.match.params;
  const initialTab = props.location.state?.initialTab;

  const [tabValue, setTabValue] = useState<number>(0);
  const [attachments, setAttachments] = useState<Array<Comprovante>>([]);
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);
  const [drawerAction, setDrawerAction] = useState<DrawerAction>(DrawerAction.CONFIRMAR);
  const [showStatusToast, setShowStatusToast] = useState<boolean>(false);
  const [operacaoDetalhes, setOperacaoDetalhes] = useState<OperacaoOfertaPrimariaResponse>();
  const [tipoLiquidacao, setTipoLiquidacao] = useState<TipoLiquidacao>(TipoLiquidacao.Direta);
  const [isLiquidacaoDireta, setIsLiquidacaoDireta] = useState<boolean>(true);
  const [openGestaoComprovantesDrawer, setOpenGestaoComprovantesDrawer] = useState<boolean>(false);
  const [gestaoComprovantesInvestidor, setGestaoComprovantesInvestidor] = useState<OfertaPrimariaInvestidorResponse | null>(null);
  const [gestaoComprovantesAttachments, setGestaoComprovantesAttachments] = useState<Array<Attachment>>([]);
  const [isSavingComprovantes, setIsSavingComprovantes] = useState<boolean>(false);
  const [comprovantesExistentes, setComprovantesExistentes] = useState<Array<ComprovanteInvestidorResponse>>([]);
  const [loadingComprovantes, setLoadingComprovantes] = useState<boolean>(false);

  const postEnviarLiquidacao = useSelector((state: RootState) => state.instrumentoApi.postEnviarLiquidacao);
  const postConfirmarLiquidacaoNotaComercial = useSelector(
    (state: RootState) => state.notaComercialApi.postConfirmarLiquidacaoNotaComercial
  );
  const postConfirmarLiquidacaoCdca = useSelector((state: RootState) => state.cdcaApi.postConfirmarLiquidacaoCdca);
  const postConfirmarLiquidacaoDebenture = useSelector(
    (state: RootState) => state.debentureApi.postConfirmarLiquidacaoDebenture
  );
  const postConfirmarLiquidacaoCri = useSelector((state: RootState) => state.criApi.postConfirmarLiquidacaoCri);
  const postConfirmarLiquidacaoCra = useSelector((state: RootState) => state.craApi.postConfirmarLiquidacaoCra);
  const postConfirmarLiquidacaoCertificadoRecebiveis = useSelector(
    (state: RootState) => state.certificadoRecebiveisApi.postConfirmarLiquidacaoCertificadoRecebiveis
  );

  const { postLiquidarOfertaPrimaria, postComprovanteInvestidorById, getComprovantesInvestidor, getComprovanteInvestidorDownloadUrl } = useSelector((state: RootState) => state.operacaoApi);


  const getCraByInstrumentoId = useSelector((state: RootState) => state.craApi.getCraByInstrumentoId);
  const getCdcaByInstrumentoId = useSelector((state: RootState) => state.cdcaApi.getCdcaByInstrumentoId);
  const getCriByInstrumentoId = useSelector((state: RootState) => state.criApi.getCriByInstrumentoId);
  const getDebentureByInstrumentoId = useSelector((state: RootState) => state.debentureApi.getDebentureByInstrumentoId);
  const getNotaComercialByInstrumentoId = useSelector(
    (state: RootState) => state.notaComercialApi.getNotaComercialByInstrumentoId
  );
  const getCertificadoRecebiveisByInstrumentoId = useSelector(
    (state: RootState) => state.certificadoRecebiveisApi.getCertificadoRecebiveisByInstrumentoId
  );

  const dispatch = useDispatch();
  const classes = useGenericStyles();
  const [filtro, setFiltro] = useState<any>();
  const history = useHistory();

  const getOperacaoOfertaPrimariaDetalhes = useSelector(
    (state: RootState) => state.operacaoApi.getOperacaoOfertaPrimariaDetalhes
  );
  const { postReprovarOfertaPrimaria, postAprovarOfertaPrimaria } =
    useSelector((state: RootState) => state.operacaoApi);
  const isParticipanteCustodiante = useSelector(
    (state: RootState) => state.auth.usuario.participante.funcao === FuncaoParticipante.Custodiante
  );

  // Botão de download na lista de investidores — comportamento original restaurado
  const getComprovanteUrl = async (comprovanteId: string, investidorId: string, name: string) => {
    try {
      const result = await getComprovanteInvestidorDownloadUrl(dispatch, operacaoId, investidorId, comprovanteId, true);
      if (result) {
        const link = document.createElement('a');
        link.href = result;
        link.target = '_blank';
        link.download = `Comprovante_${name}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.error('Erro ao fazer download do comprovante:', error);
    }
  };

  const getOperacaoDetalhes = useCallback(async () => {
    try {
      const result = await getOperacaoOfertaPrimariaDetalhes(dispatch, operacaoId, true);
      setOperacaoDetalhes(result);
    } catch { }
  }, [dispatch, getOperacaoOfertaPrimariaDetalhes, operacaoId]);

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
  };

  const handleOpenDrawer = (action: DrawerAction) => {
    setDrawerAction(action);
    setOpenDrawer(true);
  };

  const handleOpenGestaoComprovantesDrawer = (investidor: OfertaPrimariaInvestidorResponse) => {
    setGestaoComprovantesInvestidor(investidor);
    setGestaoComprovantesAttachments([]);
    setComprovantesExistentes([]);
    setOpenGestaoComprovantesDrawer(true);

    setLoadingComprovantes(true);
    getComprovantesInvestidor(dispatch, operacaoId, investidor.investidorId, false)
      .then((result) => setComprovantesExistentes(result ?? []))
      .catch(() => setComprovantesExistentes([]))
      .finally(() => setLoadingComprovantes(false));
  };

  const handleCloseGestaoComprovantesDrawer = () => {
    setOpenGestaoComprovantesDrawer(false);
    setGestaoComprovantesInvestidor(null);
    setGestaoComprovantesAttachments([]);
    setComprovantesExistentes([]);
  };

  const handleSalvarGestaoComprovantes = async () => {
    if (!gestaoComprovantesInvestidor || gestaoComprovantesAttachments.length === 0) return;
    setIsSavingComprovantes(true);
    try {
      const files = gestaoComprovantesAttachments.filter((att) => !!att.file).map((att) => att.file!);
      await postComprovanteInvestidorById(dispatch, operacaoId, gestaoComprovantesInvestidor.investidorId, files, true);
      await getOperacaoDetalhes();
      dispatch(addAlert({ severity: 'success', message: 'Comprovante(s) anexado(s) com sucesso.' }));
      handleCloseGestaoComprovantesDrawer();
    } catch (error) {
      console.error(error);
    } finally {
      setIsSavingComprovantes(false);
    }
  };

  const handleConfirmar = async () => {
    try {

      if (!operacaoDetalhes?.instrumentoFinanceiro?.valorNominalUnitarioEmissao) {
        throw new Error('Tipo de liquidação não definido na operação.');
      }
      var liquidacaoDireta = isLiquidacaoDireta ? TipoLiquidacao.Direta : TipoLiquidacao.Outras


      const request: ApproveOfertaPrimariaRequest = {
        tipoLiquidacao: liquidacaoDireta,
        custodianteId: operacaoDetalhes.custodiante.id
      }


      const result = await postLiquidarOfertaPrimaria(dispatch, operacaoId, request, true);

      if (attachments?.length > 0) {
        const comprovantesPorInvestidor = attachments.reduce((acc, comprovante) => {
          if (!acc[comprovante.investidorId]) {
            acc[comprovante.investidorId] = [];
          }
          if (comprovante.file) {
            acc[comprovante.investidorId].push(comprovante.file);
          }
          return acc;
        }, {} as Record<string, File[]>);

        await Promise.all(
          Object.entries(comprovantesPorInvestidor).map(([investidorId, files]) =>
            postComprovanteInvestidorById(dispatch, result.id, investidorId, files, true)
          )
        );
      }

      setShowStatusToast(true);
      setOperacaoDetalhes(result);
      handleCloseDrawer();
  
      setTimeout(() => {
        backToPreviousPage();
      }, 2000);
    } catch (error) { }
  };

  const handleReprovar = async () => {
    try {
      const result = await postReprovarOfertaPrimaria(dispatch, operacaoId, true);
      setShowStatusToast(true);
      setOperacaoDetalhes(result);
      handleCloseDrawer();
      
      setTimeout(() => {
        backToPreviousPage();
      }, 2000);
    } catch (error) { }
  };

  useEffect(() => {
    if (props.match.params.filtro) {
      setFiltro(props.match.params.filtro);
    }
    getOperacaoDetalhes();
  }, [getOperacaoDetalhes, props.match.params.filtro]);

  const backToPreviousPage = () => {
    if (!filtro) return history.push('/operacoes/gerenciar', { initialTab: 0 });
    else {
      const filtroJson = JSON.parse(filtro);
      return history.push(`/operacoes/gerenciar/filtro/${JSON.stringify(filtroJson)}`, { initialTab: 0 });
    }
  };

  useEffect(() => {
    if (initialTab) setTabValue(initialTab);
  }, [initialTab]);

  const statusToastByAction = useCallback(
    (action: DrawerAction) => {
      let divClassName: string = '';
      let resultDescription: string = '';
      let icon: React.ReactNode | null = null;
      switch (action) {
        case DrawerAction.REJEITAR:
          divClassName = classes.errorToast;
          resultDescription = 'rejeitada';
          icon = <Cancel style={{ marginRight: 10 }} />;
          break;
        case DrawerAction.CONFIRMAR:
          divClassName = classes.successToast;
          resultDescription = 'confirmada';
          icon = <CheckCircle style={{ marginRight: 10 }} />;
          break;
      }
      return (
        <>
          <SmSpace />
          <div className={divClassName}>
            {icon}
            <div style={{ display: 'flex', flex: 1 }}>
              <Typography variant="body2">{`Liquidação de oferta primária ${resultDescription} com sucesso.`}</Typography>
            </div>
            <IconButton onClick={() => setShowStatusToast(false)}>
              <Close />
            </IconButton>
          </div>
        </>
      );
    },
    [classes]
  );

  return (
    <div style={{ marginRight: 40 }}>
      <Typography variant="h1">{'Oferta primária'}</Typography>
      <SmSpace />

      <Button onClick={backToPreviousPage} variant="contained" color="primary">
        {'Voltar para a página anterior'}
      </Button>

      <LgSpace />
      {operacaoDetalhes && (
        <>
          <HorizontalAppBar>
            <Tabs indicatorColor="primary" value={tabValue} onChange={(_event, newTab) => setTabValue(newTab)}>
              <Tab label="Detalhes da Movimentação" />
              <Tab label="Investidores" />
              {(operacaoDetalhes.ofertaPrimaria.informacoesBancarias ?? []).length > 0 ? <Tab label="Informações Bancárias" /> : <></>}
            </Tabs>
          </HorizontalAppBar>
          {tabValue === 0 && (
            <Section title={'Detalhes da Movimentação'} defaultGrid>
              <div>
                <Typography variant="body2">{'Código:'}</Typography>
                <Typography variant="body1">{operacaoDetalhes.instrumentoFinanceiro.codigo}</Typography>
              </div>
              <div>
                <Typography variant="body2">{'Data da Solicitação:'}</Typography>
                <Typography variant="body1">{formatDate(operacaoDetalhes.dataDeCriacao)}</Typography>
              </div>
              <div>
                <Typography variant="body2">{'Quantidade alocada:'}</Typography>
                <Typography variant="body1">
                  {formatNumber(operacaoDetalhes.ofertaPrimaria.quantidadeTotal, { minimumFractionDigits: 0, maximumFractionDigits: 8 })}
                </Typography>
              </div>
              <div>
                <Typography variant="body2">{'Status:'}</Typography>
                <Typography variant="body1">{operacaoStatusDescriptions[operacaoDetalhes.status]}</Typography>
              </div>
              <div>
                <Typography variant="body2">{'Emissor:'}</Typography>
                <Typography variant="body1">{operacaoDetalhes.instrumentoFinanceiro.razaoSocialEmissor}</Typography>
              </div>
              <MdSpace />
            </Section>
          )}
          {tabValue === 1 && (
            <>
              {showStatusToast && statusToastByAction(drawerAction)}
              <MdSpace />
              <Grid container spacing={2}>
                <Grid item md={2}>
                  <Typography variant="body2" color="textSecondary">
                    {'CPF/CNPJ'}
                  </Typography>
                </Grid>
                <Grid item md={2}>
                  <Typography variant="body2" color="textSecondary">
                    {'Conta Depósito'}
                  </Typography>
                </Grid>
                <Grid item md={2}>
                  <Typography variant="body2" color="textSecondary">
                    {'Quantidade'}
                  </Typography>
                </Grid>
                <Grid item md={2}>
                  <Typography variant="body2" color="textSecondary">
                    {'PU'}
                  </Typography>
                </Grid>
                <Grid item md={4}>
                  <Typography variant="body2" color="textSecondary">
                    {'Comprovante'}
                  </Typography>
                </Grid>
              </Grid>
              <SmSpace />
              <Divider variant="fullWidth" />
              {(operacaoDetalhes.ofertaPrimaria.investidores || []).map((investidor) => (
                <React.Fragment key={investidor.investidorId}>
                  <SmSpace />
                  <Grid container spacing={2} alignItems="center">
                    <Grid item md={2}>
                      <Typography variant="body2">{addCpfCnpjMask(investidor.cpfCnpj)}</Typography>
                    </Grid>
                    <Grid item md={2}>
                      <Typography variant="body2">{investidor.contaDeposito}</Typography>
                    </Grid>
                    <Grid item md={2}>
                      <Typography variant="body2">{formatNumber(investidor.quantidade, { minimumFractionDigits: 0, maximumFractionDigits: 8 })}</Typography>
                    </Grid>
                    <Grid item md={2}>
                      <Typography variant="body2">
                        {formatEightDecimalsCurrency(investidor.precoUnitario)}
                      </Typography>
                    </Grid>
                    <Grid item md={4}>
                      <ComprovanteComponent
                        investidor={investidor}
                        status={operacaoDetalhes.status}
                        anexo={attachments.find((att) => att.investidorId === investidor.investidorId)}
                        onAdd={(anexo) => setAttachments([...attachments, anexo])}
                        onDelete={(anexo) =>
                          setAttachments(attachments.filter((att) => att.investidorId !== anexo.investidorId))
                        }
                        onDownload={(comprovanteId) => getComprovanteUrl(comprovanteId, investidor.investidorId, investidor.cpfCnpj)}
                        onGestaoComprovantes={() => handleOpenGestaoComprovantesDrawer(investidor)}
                      />
                    </Grid>
                  </Grid>
                  <SmSpace />
                  <Divider variant="fullWidth" />
                </React.Fragment>
              ))}
              <MdSpace />
            </>
          )}
          {tabValue === 2 && ((operacaoDetalhes.ofertaPrimaria.informacoesBancarias ?? []).length > 0) && (
            <Section title={'Informações Bancárias'} defaultGrid>
              <div>
                <Typography variant="body2">{'ISPB:'}</Typography>
                <Typography variant="body1">
                  {operacaoDetalhes.ofertaPrimaria.informacoesBancarias?.at(0)?.ispbBanco ?? ""}
                </Typography>
              </div>
              <div>
                <Typography variant="body2">{'Razão Social:'}</Typography>
                <Typography variant="body1">
                  {operacaoDetalhes.ofertaPrimaria.informacoesBancarias?.at(0)?.razaoSocialBanco ?? ""}
                </Typography>
              </div>
              <div>
                <Typography variant="body2">{'Agência:'}</Typography>
                <Typography variant="body1">
                  {operacaoDetalhes.ofertaPrimaria.informacoesBancarias?.at(0)?.agenciaBanco ?? ""}
                </Typography>
              </div>
              <div>
                <Typography variant="body2">{'Conta:'}</Typography>
                <Typography variant="body1">
                  {operacaoDetalhes.ofertaPrimaria.informacoesBancarias?.at(0)?.contaBanco ?? ""}
                </Typography>
              </div>
              <MdSpace />
            </Section>
          )}
          {isParticipanteCustodiante && operacaoDetalhes.status === OfertaPrimariaStatus.AguardandoConfirmacao && (
            <Grid container justify="center" spacing={8} alignItems="center" style={{ width: '100%' }}>
              <Grid item>
                <Button variant="contained" color="error" onClick={() => handleOpenDrawer(DrawerAction.REJEITAR)}>
                  {'Rejeitar Liquidação'}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => handleOpenDrawer(DrawerAction.CONFIRMAR)}
                >
                  {'Confirmar Liquidação'}
                </Button>

                <FormLabel>
                  <CustomCheckbox
                    checked={isLiquidacaoDireta}
                    onChange={(event) => setIsLiquidacaoDireta(event.target.checked)}
                  />
                  LIQUIDAÇÃO DIRETA
                </FormLabel>
              </Grid>
            </Grid>
          )}
          <LgSpace />
          <GenericDrawer
            opened={openDrawer}
            disableButtons={false}
            onClose={handleCloseDrawer}
            title={`${drawerAction === DrawerAction.CONFIRMAR ? 'Confirmar' : 'Reprovar'} Oferta Primária`}
            textContents={[
              ...(drawerAction === DrawerAction.CONFIRMAR
                ? [
                  {
                    text: `A Laqus Central Depositária S/A, poderá, conforme Regulamento e Manuais, solicitar a comprovação financeira da operação a qualquer momento e a seu exclusivo critério.`
                  },
                ]
                : []),
              {
                text: `Tem certeza que deseja ${drawerAction === DrawerAction.CONFIRMAR ? 'confirmar' : 'reprovar'
                  } a liquidação dessa oferta primária?`,
              },
            ]}
            buttons={[
              {
                buttonText: drawerAction === DrawerAction.CONFIRMAR ? 'Aceitar e Confirmar' : 'Reprovar',
                buttonAction:
                  drawerAction === DrawerAction.CONFIRMAR ? () => handleConfirmar() : () => handleReprovar(),
                buttonColor: drawerAction === DrawerAction.CONFIRMAR ? 'primary' : 'error',
              },
              {
                buttonText: 'Cancelar',
                buttonAction: () => handleCloseDrawer(),
              },
            ]}
          />

          {/* Drawer: Gestão de Comprovantes por investidor */}
          <Drawer
            anchor="right"
            open={openGestaoComprovantesDrawer}
            onClose={handleCloseGestaoComprovantesDrawer}
            PaperProps={{ style: { padding: '40px', width: 520 } }}
          >
            <Grid container>
              <Grid item xs={12}>
                <Typography variant="h3">Gestão de Comprovantes</Typography>
                <SmSpace />
                <Typography variant="body2" color="textSecondary">
                  {`Instrumento: ${operacaoDetalhes?.instrumentoFinanceiro.codigo ?? ''}`}
                </Typography>
                {gestaoComprovantesInvestidor && (
                  <Typography variant="body2" color="textSecondary">
                    {`Investidor: ${addCpfCnpjMask(gestaoComprovantesInvestidor.cpfCnpj)}`}
                  </Typography>
                )}
                <SmSpace />
                <Divider variant="fullWidth" />
                <SmSpace />
              </Grid>

              <Grid item xs={12}>
                <UploadDocs
                  multipleFiles
                  onChange={(atts) => setGestaoComprovantesAttachments((prev) => [...prev, ...atts])}
                  onDelete={(id) => setGestaoComprovantesAttachments((prev) => prev.filter((att) => att.id !== id))}
                />
              </Grid>

              {/* Comprovante existente do investidor */}
              <Grid item xs={12}>
                <MdSpace />
                <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                  Comprovantes Existentes
                </Typography>
                <SmSpace />
                {loadingComprovantes && (
                  <Typography variant="body2" color="textSecondary">Carregando...</Typography>
                )}
                {!loadingComprovantes && comprovantesExistentes.length === 0 && (
                  <Typography variant="body2" color="textSecondary">Nenhum comprovante anexado.</Typography>
                )}
                {!loadingComprovantes && comprovantesExistentes.map((comp) => (
                  <React.Fragment key={comp.id}>
                    <Grid container alignItems="center" spacing={1} style={{ paddingTop: 8, paddingBottom: 8 }}>
                      <Grid item>
                        <Description fontSize="small" />
                      </Grid>
                      <Grid item xs>
                        <Typography variant="body2">
                          {`${comp.fileName}${comp.extension} - ${(comp.size / (1024 * 1024)).toFixed(2)}MB`}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Button
                          variant="text"
                          size="small"
                          startIcon={<GetApp fontSize="small" />}
                          onClick={() => {
                            if (comp.url) {
                              window.open(comp.url, '_blank');
                            }
                          }}
                        >
                          Download
                        </Button>
                      </Grid>
                    </Grid>
                    <Divider variant="fullWidth" />
                  </React.Fragment>
                ))}
              </Grid>

              <Grid item xs={12}>
                <LgSpace />
                <Button
                  onClick={handleSalvarGestaoComprovantes}
                  variant="contained"
                  color="primary"
                  fullWidth
                  disabled={gestaoComprovantesAttachments.length === 0 || isSavingComprovantes}
                >
                  {isSavingComprovantes ? 'Enviando...' : 'Enviar Comprovante'}
                </Button>
                <SmSpace />
                <Button
                  onClick={handleCloseGestaoComprovantesDrawer}
                  variant="outlined"
                  fullWidth
                >
                  Fechar
                </Button>
              </Grid>
            </Grid>
          </Drawer>
        </>
      )}
    </div>
  );
};

export default DetalhesOfertaPrimaria;
